import { styled } from '@volkswagen-onehub/components-core';
import zIndex from '@/modules/constants/zIndex';
import type { BreakpointsProps } from '@/types';
import {
  convertBreakpointsToMediaQueries,
  jssToCss,
} from '@/modules/utils/themeUtils';

interface StyledGalleryViewerProps
  extends BreakpointsProps<StyledGalleryViewerProps> {
  width?: string;
  height?: string;
  offsetTop?: number;
}

export const StyledGalleryViewer = styled.div<StyledGalleryViewerProps>(
  ({ width, height, offsetTop = 0, ...restProps }) => `
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    position: relative;
    max-height: calc(100vh - ${offsetTop}px);
    overflow: hidden;

    ${jssToCss({
      width,
      height,
    })}

    ${convertBreakpointsToMediaQueries({
      b960: {
        ...restProps['b960'],
        position: 'relative',
        minHeight: '108px',
        height: '100%',
      },
    })};
  `
);

export const StyledGalleryViewerCTAs = styled.div(
  ({ theme }) => `
    display: flex;
    align-items: center;
    z-index: ${zIndex.FOREGROUND};
    position: absolute;
    top: 0;
    left: ${theme.size.static250};
    right: ${theme.size.static250};

    ${convertBreakpointsToMediaQueries({
      b960: {
        top: theme.size.static400,
        left: theme.size.static450,
        right: theme.size.static450,
      },
    })};
  `
);

export const StyledGalleryViewerCTAsWrapper = styled.div(
  ({ theme }) => `
  min-height: ${theme.size.static250}px;

  ${convertBreakpointsToMediaQueries({
    b960: {
      minHeight: 'initial',
    },
  })};
`
);

export const StyledGalleryViewerTabs = styled.div(
  () => `
    flex-grow: 1;
    text-align: right;
    display: flex;
    justify-content: flex-end;
  `
);
